'use client';

import dynamic from 'next/dynamic';

// Google Maps and the form stack: imported from the server block they became entry scripts on every page
export const ContactForm = dynamic(() => import('./ContactForm'));
export const ContactMap = dynamic(() => import('./Map'));
